import { defineComponent as _defineComponent } from 'vue'
import { onMounted, onBeforeUnmount, nextTick, watch, getCurrentInstance } from 'vue';
import { navigationService } from "vue-spatialnavigation";
import { CMSRailManager } from "@/services/CMSRailManager";
import { focusElementById, nothingHasFocus } from '@/helpers/focus';
import { railFocusMemory } from '@/helpers/railFocusMemory';
import TG4Loader from '@/components/TG4Loader.vue';
import TG4Button from '@/components/TG4Button.vue';
import RailsContainer from '@/components/containers/RailsContainer.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Rails',
  setup(__props) {

const instance = getCurrentInstance();

const retryLoad = () => {
  CMSRailManager.refreshRails();
};


const claimFocusIfLost = () => {
  if (!nothingHasFocus()) return;

  const remembered = `rail-${railFocusMemory.get()}-0`;

  focusElementById(remembered, { scroll: true })
    || focusElementById('rail-0-0', { scroll: true })
    || focusElementById('nav-home');
};

onMounted(async () => {
  navigationService.blockAllSpatialNavigation = true;
  instance?.proxy?.$recordEvent('home-view-selected');
  setTimeout(() => {
    navigationService.blockAllSpatialNavigation = false;
  }, 300);

  claimFocusIfLost();

  CMSRailManager.startPolling();
});


watch(() => CMSRailManager.rails.value, () => nextTick(claimFocusIfLost));

onBeforeUnmount(() => {
  CMSRailManager.stopPolling();
});





return { __sfc: true,instance, retryLoad, claimFocusIfLost, CMSRailManager, TG4Loader, TG4Button, RailsContainer }
}

})